import {Component, OnInit} from '@angular/core';
import { MessageService } from './../services/message-service';

@Component({
    selector: 'dk-info-box',
    template: require('./info-box.html'),
    providers: [MessageService]
})

export class InfoBoxComponent implements OnInit {
    messages: Message[];

    constructor(private messageService: MessageService) {
        this.messages = [];

        this.messageService.addOnSuccess(content => {
            this.add(content, "success");
            setTimeout(() => {
                $('html, body').animate({
                    scrollTop: $("#info-box-messages").offset().top - 100
                }, 1000);
            }, 100);
        });

        this.messageService.addOnError(content => {
            this.add(content, "error");
            setTimeout(() => {
                $('html, body').animate({
                    scrollTop: $("#info-box-messages").offset().top - 100
                }, 1000);
            }, 100);
        });
    }

    public ngOnInit() {
    }

    private add(content: string, type: string) {
        let message = new Message();
        message.type = type;
        message.content = content;
        // message.isShown = true;
        //
        // let timer = Observable.timer(5000, 0).take(1);
        //
        // timer.subscribe(t => {
        //     message.isShown = false;
        // });

        this.messages.push(message);
    }
}

class Message {
    type: string;
    content: string;
    //isShown: boolean;
}
